import React from 'react';
import config from 'config';
import { Row, Input } from 'reactstrap';

export const renderTileLayerMenu = (drawing, setDrawing) => {
	return (
		<div id="mapStyleMenu">
			<Row className="d-flex justify-content-center p-0 m-0">
				{config.mapbox_styles.map(({ stylename, url }, idx) => (
					<div key={`key${idx}`} className="py-2 m-0">
						<label className="px-1 m-0">
							<Input
								className="py-0 mapRadios"
								id="drawStyle"
								type="radio"
								name="rtoggle"
								value={url}
								defaultChecked={drawing.tileLayer === url}
								onClick={() =>
									setDrawing((prev) => ({ ...prev, tileLayer: url }))
								}
							></Input>
							<img
								className="map-radio-imgs"
								src={require(`images/${stylename}.png`)}
								alt={stylename}
							></img>
						</label>
					</div>
				))}
			</Row>
		</div>
	);
};
